import { PRODUCTS_SLUG_PREFIX } from '@components/utils/constants'
import { groupBy } from '@framework/utils/lodash'
import { matchStrings } from '@framework/utils/parse-util'
import { useRouter } from 'next/router'
import { useState } from 'react'

interface IProps {
  fieldCode: string
  isMobile: boolean
  isIPadorTablet: boolean
  items: any
  currentVariantData: any
  isLoadedOnMobile: boolean
  onChange: (fieldCode: string, value: string, obj?: any) => void
}

const useProductColorsPDP = ({
  fieldCode,
  isMobile,
  isIPadorTablet,
  items,
  currentVariantData,
  isLoadedOnMobile,
  onChange,
}: IProps) => {
  const router = useRouter()

  const slug = `${PRODUCTS_SLUG_PREFIX}${router.query.slug}`
  let objValue: any
  const [selectedGroupName, setSelectedGroupName] = useState<any>(undefined)
  const handleChange = (
    key: string,
    value: any,
    ColorItem: any,
    idx: any,
    values?: Array<any>
  ) => {
    if (values?.length) {
      let obj: any = {}
      obj[key] = values?.find((x: any) =>
        matchStrings(x?.fieldValue, value, true)
      )?.fieldLabel
      objValue = values?.find((x: any) =>
        matchStrings(x?.fieldValue, value, true)
      )

      setSelectedGroupName({
        //...selectedGroupName || {},
        ...{ ...obj },
      })
    }

    return onChange(fieldCode, value, ColorItem)
  }
  const [isActive, setActive] = useState(0)

  const onTabCick = (id: number) => {
    setActive(id)
  }
  const arrItems = new Array(...items)
  const all =
    isMobile || isIPadorTablet || isLoadedOnMobile
      ? {
          All:
            arrItems?.length > 0
              ? arrItems?.sort(
                  (a: { displayOrder: number }, b: { displayOrder: number }) =>
                    a.displayOrder - b.displayOrder
                )
              : [],
        }
      : {}

  const groups: any = groupBy(
    items
      ?.map((color: any) => {
        const colorObj = { ...color };
        if (
          (isMobile || isIPadorTablet || isLoadedOnMobile) &&
          !color.fieldGroupName
        ) {
          colorObj.fieldGroupName = 'Colour'
        }
        return colorObj
      })
      ?.sort(
        (a: { displayOrder: number }, b: { displayOrder: number }) =>
          a.displayOrder - b.displayOrder
      ),
    'fieldGroupName'
  )
  const groupsLen = Object.entries(groups)?.length

  let index = 0
  let defaultFieldLabel = ''
  do {
    const defaultAttributes: any = Object.entries(groups)
      ?.sort()
      ?.find(([key, values]: any, idx: number) => idx == index)
    if (defaultAttributes?.length) {
      defaultFieldLabel = defaultAttributes[1]?.find((x: any) =>
        matchStrings(x?.fieldValue, currentVariantData, true)
      )?.fieldLabel
    }

    if (!defaultFieldLabel) {
      index++
    } else {
      index = groupsLen
    }
  } while (index <= groupsLen - 1)

  const getAllGroups = () => {
    const grps = Object.assign({}, groups)
    const allTab = Object.entries(all)?.sort()
    const restTabs = Object.entries(grps)?.sort()

    return [...allTab, ...restTabs]
  }

  const handleError = (e: any) => {
    e.target.srcset = '/imagePlaceHolder.jpg?w=96'
  }

  return {
    slug,
    isActive,
    selectedGroupName,
    handleChange,
    onTabCick,
    getAllGroups,
    handleError,
  }
}

export { useProductColorsPDP }
